import { Address1_2 } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    title: "宛先１",
    keyword: "addressKbn1",
    type: "radio",
    radioPropsList: TkGetCodeList(Address1_2),
    requiredIcon: true,
  },
  {
    title: "宛先２",
    keyword: "addressKbn2",
    type: "nodeInLine",
    requiredIcon: true,
  },
  {
    title: "都道府県",
    keyword: "prefectures",
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "テンプレート",
    keyword: "tempName",
    type: "selectForm",
    requiredIcon: true,
  },
  {
    title: "タイトル",
    keyword: "title",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
    disabled: false,
  },
  {
    title: "本文",
    keyword: "text",
    type: "textarea",
    requiredIcon: true,
    inputProps: { maxLength: 1000 },
    showLimit: true,
    rows: 20,
    disabled: false,
  },
];

const schema = {
  addressKbn1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  title: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  text: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1000"),
    },
  },
};

export { tableList, schema };
